import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";
import { Safeguard } from "@scenes/safeguard";
import { Props } from "./types";
import icon from "./icon.png";
import styles from "./styles.scss";

function AssistantShortcut(_: Props) {
  const { t } = useTranslation();

  return (
    <Safeguard useCases={[UseCases.retrieveConversations]}>
      {({ canRetrieveConversations }) =>
        canRetrieveConversations && (
          <NavLink to="/assistant" className={styles.assistantShortcut}>
            <img
              src={icon}
              className={styles.icon}
              alt={t("layout.navigation.assistant")}
            />
          </NavLink>
        )
      }
    </Safeguard>
  );
}

export { AssistantShortcut };
